import { useCallback } from 'react';
import { generatePath, useHistory, useParams } from 'react-router';
import { BulkRetargetingRoutes } from 'sections/bulk-retargeting-campaigns/routes';

export const useNavigateToAudience = () => {
  const history = useHistory();
  const { siteId, campaignId } = useParams<{ siteId: string; campaignId: string }>();

  return useCallback(() => {
    history.push(generatePath(BulkRetargetingRoutes.EDIT_AUDIENCE, { siteId, campaignId }));
  }, [campaignId, history, siteId]);
};
